<template>
	<div class="user">
		<basic-container>
			<el-row :span="24">
				<el-col :md="24" :sm="24" :xs="24" class="user__main">
					<avue-crud
						ref="crud"
						v-model="form"
						:before-open="onHandleBeforeOpen"
						:data="list"
						:option="option"
						:page.sync="page"
						:table-loading="listLoading"
						@on-load="getList"
						@search-change="searchChange"
						@refresh-change="refreshChange"
						@size-change="sizeChange"
						@current-change="currentChange"
						@row-update="update"
						@row-save="create">
						<template slot="menuLeft">
							<el-button
								v-if="team_place_add && isShowAdd"
								class="filter-item"
								icon="el-icon-edit"
								size="small"
								type="primary"
								@click="$refs.crud.rowAdd()">
								添加
							</el-button>
						</template>
						<template slot="contactPerson" slot-scope="scope">
							<span>{{ scope.row.contactPerson }}</span>
						</template>
						<template slot="contactPersonMobile" slot-scope="scope">
							<span>{{ scope.row.contactPersonMobile }}</span>
						</template>
						<template slot="name" slot-scope="scope">
							<span>{{ scope.row.name }}</span>
						</template>
						<!-- <template
              slot="status"
              slot-scope="scope">
              <el-tag>{{ scope.label }}</el-tag>
            </template> -->
						<template slot="remark" slot-scope="scope">
							<span>{{ scope.row.remark }}</span>
						</template>
						<template slot="createAt" slot-scope="scope">
							<span>{{ scope.row.createAt }}</span>
						</template>
						<template slot="menu" slot-scope="{row, index}">
							<el-button
								v-if="team_place_edit"
								icon="el-icon-edit"
								size="small"
								type="text"
								@click="handleUpdate(row, index)">
								编辑
							</el-button>
							<el-button
								v-if="team_place_del"
								icon="el-icon-delete"
								size="small"
								type="text"
								@click="deletes(row, index)">
								删除
							</el-button>
							<el-button
								v-if="team_place_edit"
								icon="el-icon-edit"
								size="small"
								type="text"
								@click="onSetAddress(row, index)">
								专票地址
							</el-button>
						</template>
					</avue-crud>
				</el-col>
			</el-row>
		</basic-container>

		<el-dialog :visible.sync="isShowSetAddress" title="专票地址" top="25vh" width="55%"></el-dialog>
	</div>
</template>

<script>
import {addObj, delObj, fetchPlaceList, putObj} from '@/api/team/place'
import {tableOption} from '@/const/crud/team/place'
import {mapGetters} from 'vuex'
import {rule} from '@/util/validateRules'
import {getChannelMainInfo} from '@/api/insurance/policy'
import {decryptMessageByObject} from '@/util/secret'

export default {
	name: 'TeamPlace',
	data() {
		return {
			searchForm: {},
			treeOption: {
				nodeKey: 'id',
				addBtn: false,
				menu: false,
				props: {
					label: 'name',
					value: 'id',
				},
			},
			treeData: [],
			option: tableOption,
			checkedKeys: [],
			defaultProps: {
				label: 'name',
				value: 'id',
			},
			page: {
				total: 0, // 总页数
				currentPage: 1, // 当前页数
				pageSize: 20, // 每页显示多少条,
				pageSizes: [10, 20, 30, 40, 50, 100, 1000],
				isAsc: false, // 是否倒序
			},
			list: [],
			listLoading: true,
			form: {},
			editShowing: false,
			isShowSetAddress: false,
			channelId: '',
			isShowAdd: true,
		}
	},
	computed: {
		...mapGetters(['permissions', 'userInfo']),
	},
	// watch: {
	//   role() {
	//     this.form.role = this.role
	//   }
	// },
	watch: {
		'form.resetpassword'(val, oldVal) {
			if (this.editShowing === true) {
				let password = this.findObject(this.option.column, 'password')
				if (val === 1) {
					password.rules = [{required: true, validator: rule.validatorPass, trigger: 'blur'}]
					password.editDisabled = false
					this.form.password = undefined
				} else {
					password.rules = [{required: false}]
					password.editDisabled = true
					if (oldVal === 1 && this.$refs.crud) {
						this.$nextTick(() => {
							this.$refs.crud.clearValidate() // 只清除清除验证
						})
					}
				}
			}
		},
	},
	created() {
		this.initData()
	},
	methods: {
		async initData() {
			this.team_place_add = this.permissions['dist_distChannel_add']
			this.team_place_edit = this.permissions['dist_distChannel_edit']
			this.team_place_del = this.permissions['dist_distChannel_del']

			let {distAccount = {}} = this.userInfo
			let {channelId = '', mainChannelId = ''} = distAccount
			if (mainChannelId !== '' && channelId === mainChannelId) {
				//主渠道 获取渠道信息
				let resultData = (await getChannelMainInfo()) || {}
				let {code = -1, data = {}} = resultData.data
				if (code === 0) {
					let {limitAddChannel = 0} = data
					this.isShowAdd = limitAddChannel === 0
				}
			}
		},
		getList(page, params) {
			this.listLoading = true
			fetchPlaceList(
				Object.assign(
					{
						current: page.currentPage,
						size: page.pageSize,
					},
					params,
					this.searchForm,
				),
			).then((response) => {
				this.list = response.data.data.records
				this.page.total = response.data.data.total
				this.listLoading = false
			})
		},
		searchChange(param, done) {
			this.searchForm = param
			this.page.currentPage = 1
			this.getList(this.page, param)
			done()
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize
		},
		currentChange(current) {
			this.page.currentPage = current
		},
		refreshChange() {
			this.getList(this.page)
		},
		async onHandleBeforeOpen(show, type) {
			window.boxType = type

			let password = this.findObject(this.option.column, 'password')

			if (['edit', 'views'].includes(type)) {
				sessionStorage.setItem('validHasBeenPresence_edit', JSON.stringify({type: '2', value: this.form.id}))
				this.editShowing = true
				password.span = 8
			} else if (type === 'add') {
				sessionStorage.removeItem('validHasBeenPresence_edit')
				this.form.username = undefined
				this.form.phone = undefined
				this.form.password = undefined

				this.editShowing = false
				password.span = 12
			}
			let {settleAccounts = []} = this.form
			if (settleAccounts.length > 0) {
				let {userName = '', idNo = '', bankName = '', cardNo = '', cardNoCrypt = '', idNoCrypt = ''} = settleAccounts[0]
				Object.assign(this.form, {userName, idNo, bankName, cardNo, cardNoCrypt, idNoCrypt})
			}
			//解密 this.form
			let tempData = await decryptMessageByObject(this.form)
			Object.assign(this.form, tempData)

			show()
		},
		handleUpdate(row, index) {
			this.$refs.crud.rowEdit(row, index)
			this.form.password = undefined
		},
		create(row, done, loading) {
			if (this.form.phone && this.form.phone.indexOf('*') > 0) {
				this.form.phone = undefined
			}
			// Added by Li Yong on 2021/09/05
			// 新增渠道管理员账户默认为需重置密码状态
			this.form.passwordStatus = 1
			// 子渠道登录手机号和联系手机号统一
			if (!this.form.loginMobile && this.form.contactPersonMobile) {
				this.form.loginMobile = this.form.contactPersonMobile
			}
			let {userName = '', idNo = '', bankName = '', cardNo = ''} = this.form
			let requestData = this.deepClone(this.form)
			if (userName && idNo && bankName && cardNo) {
				requestData.settleAccounts = [
					{
						userName,
						idNo,
						bankName,
						cardNo,
						sort: 1,
						type: 'PRIVATE',
						channelId: 0,
					},
				]
			} else {
				if (userName || idNo || bankName || cardNo) {
					this.$alert('请填写完整结算账户信息！').then(() => {})
					loading()
					return
				}
			}

			//删除空数据
			for (let formKey in requestData) {
				if (requestData[formKey] === '') {
					this.$delete(requestData, formKey)
				}
			}
			addObj(requestData)
				.then(() => {
					this.getList(this.page)
					done()
					this.$notify.success('创建成功')
				})
				.catch(() => {
					loading()
				})
				.finally(() => {})
		},
		update(row, index, done, loading) {
			//结构
			let {phone = '', resetpassword = -1, loginMobile = '', contactPersonMobile = ''} = this.form
			if (phone && phone.indexOf('*') > 0) {
				this.form.phone = undefined
			}
			// Added by Li Yong on 2021/09/05
			this.form.passwordStatus = resetpassword === 1 ? 1 : 0
			// 子渠道登录手机号和联系手机号统一
			if (contactPersonMobile && loginMobile !== contactPersonMobile) {
				this.form.loginMobile = contactPersonMobile
			}

			let {userName = '', idNo = '', bankName = '', cardNo = ''} = this.form
			let requestData = this.deepClone(this.form)
			if (userName && idNo && bankName && cardNo) {
				requestData.settleAccounts = [
					{
						userName,
						idNo,
						bankName,
						cardNo,
						sort: 1,
						type: 'PRIVATE',
						channelId: 0,
					},
				]
			} else {
				if (userName || idNo || bankName || cardNo) {
					this.$alert('请填写完整结算账户信息！').then(() => {})
					loading()
					return
				} else {
					requestData.settleAccounts = []
				}
			}

			putObj(requestData)
				.then(() => {
					this.getList(this.page)
					done()
					this.$notify.success('修改成功')
				})
				.catch(() => {
					loading()
				})
				.finally(() => {
					this.form.loginMobile = ''
				})
		},
		deletes(row, index) {
			this.$confirm('此操作将永久删除该渠道(渠道名:' + row.name + '), 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				delObj(row.id)
					.then(() => {
						this.list.splice(index, 1)
						this.$notify.success('删除成功')
					})
					.catch(() => {
						this.$notify.error('删除失败')
					})
			})
		},
		onSetAddress(row, index) {
			this.channelId = row.id
			this.isShowSetAddress = true
		},
		onAddressClose() {
			this.isShowSetAddress = false
			//刷新
			this.refreshChange()
		},
	},
}
</script>

<style lang="scss">
.user {
	height: 100%;

	&__tree {
		padding-top: 3px;
		padding-right: 20px;
	}
}
</style>
